<template>
  <Report
      :filters="filters"
      :header="header"
      module="Estoque"
      name="Produtos"
      urlGet="/api/v1/stock/report/product"
  />
</template>

<script>
import Report from "@nixweb/nixloc-ui/src/component/report/Report";

export default {
  name: "ReportProductView",
  components: {
    Report,
  },
  data() {
    return {
      header: [
        {
          title: "Cód. Interno",
          field: "codInternal",
          fieldOrderBy: "CodInternal",
          show: false,
          styleHeader: "width:100px;",
          styleBody: "max-width: 90px;",
        },
        {
          title: "Tipo",
          field: "typeName",
          fieldOrderBy: "TypeName",
          show: false,
          styleHeader: "width:100px;",
          styleBody: "max-width: 90px;",
        },
        {
          title: "Tipo de Produto",
          field: "typeProductName",
          fieldOrderBy: "TypeProductName",
          show: true,
          styleHeader: "width:300px;",
          styleBody: "max-width: 300px;",
        },
        {
          title: "Produto",
          field: "productName",
          fieldOrderBy: "ProductName",
          show: true,
          initialOrderBy: true,
          styleHeader: "width:300px;",
          styleBody:
              "max-width: 290px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;",
        },
        {
          title: "Categoria",
          field: "categoryProductName",
          fieldOrderBy: "CategoryProductName",
          show: true,
          styleHeader: "width:160px;",
          styleBody:
              "max-width: 150px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;",
        },
        {
          title: "Fabricante",
          field: "manufacturerName",
          fieldOrderBy: "ManufacturerName",
          show: false,
          styleHeader: "width:160px;",
          styleBody:
              "max-width: 150px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;",
        },
        {
          title: "Cod. Grupo",
          field: "barCode",
          fieldOrderBy: "BarCode",
          show: false,
          styleHeader: "width:120px;",
          styleBody: "max-width: 110px;",
        },
        {
          title: "Unid. Medida",
          field: "unitOfMeasurementName",
          fieldOrderBy: "UnitOfMeasurementName",
          show: false,
          styleHeader: "width:120px;",
          styleBody: "max-width: 110px;",
        },
        {
          title: "Dt Compra",
          field: "purchaseDate",
          fieldOrderBy: "PurchaseDate",
          show: false,
          styleHeader: "width:100px;",
          styleBody: "max-width: 90px;",
        },
        {
          title: "Patrimoniado",
          field: "allowWithoutPatrimonyName",
          fieldOrderBy: "AllowWithoutPatrimonyName",
          show: false,
          styleHeader: "width:110px;",
          styleBody: "max-width: 100px;",
        },
        {
          title: "Status",
          field: "statusName",
          fieldOrderBy: "StatusName",
          show: false,
          styleHeader: "width:80px;",
          styleBody: "max-width: 70px;",
        },
        {
          title: "Cliente",
          field: "customerName",
          fieldOrderBy: "CustomerName",
          show: false,
          styleHeader: "width:220px;",
          styleBody:
              "max-width: 210px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;",
        },
        {
          title: "Nº Locação",
          field: "numberRent",
          fieldOrderBy: "NumberRent",
          show: false,
          styleHeader: "width:100px;",
          styleBody: "max-width: 90px;",
        },
        {
          title: "Patrimônio",
          field: "totalPatrimony",
          fieldOrderBy: "TotalPatrimony",
          show: false,
          styleHeader: "width:90px;",
          styleBody: "max-width: 80px;",
        },
        {
          title: "Estoque",
          field: "totalStock",
          fieldOrderBy: "TotalStock",
          show: true,
          styleHeader: "width:80px;",
          styleBody: "max-width: 70px;",
        },
        {
          title: "Reservado",
          field: "totalReserved",
          fieldOrderBy: "TotalReserved",
          show: true,
          styleHeader: "width:90px;",
          styleBody: "max-width: 80px;",
        },
        {
          title: "Locado",
          field: "totalRented",
          fieldOrderBy: "TotalRented",
          show: true,
          styleHeader: "width:80px;",
          styleBody: "max-width: 70px;",
        },
        {
          title: "Devolvido",
          field: "totalReturned",
          fieldOrderBy: "TotalReturned",
          show: false,
          styleHeader: "width:90px;",
          styleBody: "max-width: 80px;",
        },
        {
          title: "Disponível",
          field: "totalAvailable",
          fieldOrderBy: "TotalAvailable",
          show: true,
          styleHeader: "width:90px;",
          styleBody: "max-width: 80px;",
        },
        {
          title: "Vl. Reposição",
          field: "replacementValue",
          fieldOrderBy: "ReplacementValue",
          show: false,
          styleHeader: "width:120px;",
          styleBody: "max-width: 110px;",
        },
        {
          title: "Total Reposição",
          field: "totalReplacementValue",
          fieldOrderBy: "TotalReplacementValue",
          show: false,
          styleHeader: "width:130px;",
          styleBody: "max-width: 120px;",
        },
      ],
      filters: [
        {
          type: "text",
          title: "Código Interno",
          field: "CodInternal",
          value: "",
        },
        {
          type: "options",
          title: "Tipo",
          field: "TypeName",
          options: [
            {text: "Equipamento", value: "Equipamento"},
            {text: "Acessório", value: "Acessório"},
            {text: "Material", value: "Material"},
            {text: "Serviço", value: "Serviço"},
          ],
          value: [],
        },
        {
          type: "multiOptions",
          title: "Tipo de Produto",
          field: "TypeProductName",
          url: "/api/v1/stock/type-product/select-all",
          propsParams: {},
          value: "",
        },
        {
          type: "multiOptions",
          title: "Produto",
          field: "ProductName",
          url: "/api/v1/stock/product/select-all",
          propsParams: {},
          value: "",
        },
        {
          type: "multiOptions",
          title: "Categoria",
          field: "CategoryProductName",
          url: "/api/v1/stock/category-product/select-all",
          propsParams: {},
          value: "",
        },
        {
          type: "multiOptions",
          title: "Fabricante",
          field: "ManufacturerName",
          url: "/api/v1/stock/manufacturer/select-all",
          propsParams: {},
          value: "",
        },
        {
          type: "text",
          title: "Cod. Grupo",
          field: "BarCode",
          value: "",
        },
        {
          type: "multiOptions",
          title: "Unid. Medida",
          field: "UnitOfMeasurementName",
          url: "/api/v1/stock/unit-of-measurement/select-all",
          propsParams: {},
          value: "",
        },
        {
          type: "date",
          title: "Data Compra",
          field: "PurchaseDate",
          value: "",
          required: false,
        },
        {
          type: "options",
          title: "Patrimoniado",
          field: "AllowWithoutPatrimonyName",
          options: [
            {text: "Sim", value: "Sim"},
            {text: "Não", value: "Não"},
          ],
          value: [],
        },
        {
          type: "options",
          title: "Status",
          field: "StatusName",
          options: [
            {text: "Ativo", value: "Ativo"},
            {text: "Inativo", value: "Inativo"},
          ],
          value: [],
        },
        {
          type: "multiOptions",
          title: "Cliente",
          field: "CustomerName",
          url: "/api/v1/crm/customer/select-all-without-document",
          propsParams: {isCustomer: true, isSupplier: false},
          value: "",
        },
        {
          type: "decimal",
          title: "Patrimônio",
          field: "TotalPatrimony",
          valueStart: 0,
          valueEnd: 0,
        },
        {
          type: "options",
          title: "Estoque",
          field: "TotalStockName",
          options: [
            {text: "Com Estoque", value: "Com Estoque"},
            {text: "Sem Estoque", value: "Sem Estoque"},
          ],
          value: [],
        },
        {
          type: "options",
          title: "Reservado",
          field: "TotalReservedName",
          options: [
            {text: "Com Reserva", value: "Com Reserva"},
            {text: "Sem Reserva", value: "Sem Reserva"},
          ],
          value: [],
        },
        {
          type: "options",
          title: "Locado",
          field: "TotalRentedName",
          options: [
            {text: "Com Locação", value: "Com Locação"},
            {text: "Sem Locação", value: "Sem Locação"},
          ],
          value: [],
        },
        {
          type: "options",
          title: "Devolvido",
          field: "TotalReturnedName",
          options: [
            {text: "Com Retorno", value: "Com Retorno"},
            {text: "Sem Retorno", value: "Sem Retorno"},
          ],
          value: [],
        },
        {
          type: "options",
          title: "Disponível",
          field: "TotalAvailableName",
          options: [
            {text: "Disponível", value: "Disponível"},
            {text: "Indisponível", value: "Indisponível"},
          ],
          value: [],
        },
        {
          type: "decimal",
          title: "Vl. Reposição",
          field: "ReplacementValue",
          valueStart: 0,
          valueEnd: 0,
        },
        {
          type: "decimal",
          title: "Total Reposição",
          field: "TotalReplacementValue",
          valueStart: 0,
          valueEnd: 0,
        },
      ],
    };
  },
};
</script>
